const pxToRem = (value = 0) => {
  const remVar = 16
  return value / remVar
}

export { pxToRem }
